<!-- 服务项目信息编辑页 -->
<template>
  <div class="edit white">
    <el-dialog :title="addEditTitle" :visible.sync="addEditShow" :before-close="handleChangeDrawer">
        <div class="pay-mains">
          <el-form
            ref="form"
            :model="form"
            class="demo-ruleForm"
            label-width="60px"
            label-position="left"
          >
            <div v-if="itemType != 'recharge'">
              <div v-if="itemType == 'serve'">
                <el-form-item
                  class="align-item"
                  ref="workDeductWay"
                  label="提成"
                  prop="workDeductWay"
                  :rules="$rules.required"
                >
                  <el-radio-group v-model="form.workDeductWay" class="ductway">
                    <el-radio label="ratio">比例提成</el-radio>
                    <el-radio label="fixed">固定提成</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item
                  class="align-item"
                  ref="deductPriceType"
                  label="价格"
                  prop="deductPriceType"
                  :rules="$rules.required"
                >
                  <el-radio-group v-model="form.deductPriceType" style="width: 270px;">
                    <el-radio label="original">销售价</el-radio>
                    <el-radio label="sale">实付价</el-radio>
                    <el-radio label="discount">折扣价</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item
                  class="align-item"
                  ref="customerWorkDeductAmount"
                  label="散客"
                  prop="customerWorkDeductAmount"
                >
                  <div style="display: flex;">
                    <el-input v-model="form.customerWorkDeductAmount" placeholder="请输入" maxlength="8">
                      <span slot="suffix">{{ form.workDeductWay == 'ratio' ? '%':'元' }}</span>
                    </el-input>
                  </div>
                </el-form-item>
                <el-form-item
                  class="align-item"
                  ref="workDeductAmount"
                  label="会员"
                  prop="workDeductAmount"
                >
                  <div style="display: flex;">
                    <el-input v-model="form.workDeductAmount" placeholder="请输入" maxlength="8">
                      <span slot="suffix">{{ form.workDeductWay == 'ratio' ? '%':'元' }}</span>
                    </el-input>
                  </div>
                </el-form-item>
              </div>
              <div v-else>
                <el-form-item
                  class="align-item"
                  ref="saleDeductWay"
                  label="提成"
                  prop="saleDeductWay"
                  :rules="$rules.required"
                >
                  <el-radio-group v-model="form.saleDeductWay">
                    <el-radio label="ratio">比例提成</el-radio>
                    <el-radio label="fixed">固定提成</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item
                  class="align-item"
                  ref="deductPriceType"
                  label="价格"
                  prop="deductPriceType"
                  :rules="$rules.required"
                >
                  <el-radio-group v-model="form.deductPriceType" style="width: 270px;">
                    <el-radio label="original">销售价</el-radio>
                    <el-radio label="sale">实付价</el-radio>
                    <el-radio label="discount">折扣价</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item
                  class="align-item"
                  ref="customerSaleDeductAmount"
                  label="散客"
                  prop="customerSaleDeductAmount"
                >
                <div class="flex-row">
                  <el-input v-model="form.customerSaleDeductAmount" placeholder="请输入" maxlength="8">
                    <span slot="suffix">{{ form.saleDeductWay == 'ratio' ? '%':'元' }}</span>
                  </el-input>
                </div>
                </el-form-item>
                <el-form-item
                  class="align-item"
                  ref="saleDeductAmount"
                  label="会员"
                  prop="saleDeductAmount"
                >
                  <div class="flex-row">
                    <el-input v-model="form.saleDeductAmount" placeholder="请输入" maxlength="8">
                      <span slot="suffix">{{ form.saleDeductWay == 'ratio' ? '%':'元' }}</span>
                    </el-input>
                  </div>
                </el-form-item>
              </div>
            </div>

            <div v-else>
              <el-form-item class="align-item" ref="deductWay" label="提成" prop="deductWay">
                <el-radio-group v-model="form.deductWay">
                  <el-radio label="ratio">比例提成</el-radio>
                  <el-radio label="fixed">固定提成</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item
                class="align-item"
                ref="deductTypeCn"
                label="类型"
                prop="deductTypeCn"
              >
                <p v-if="form.id != ''" style="width: 190px;">{{ form.deductTypeCn }}</p>
                <el-radio-group v-model="form.deductType" style="width: 190px;" v-else>
                  <el-radio label="startRecharge">首充</el-radio>
                  <el-radio label="endRecharge">续充</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="规则" class="align-item msgs" required>
                <div style="display: flex;">
                  <div><el-input v-model="form.startInterval" placeholder="请输入" maxlength="8">
                    <span slot="suffix">元</span>
                  </el-input></div>
                  <div style="padding: 0 10px;">-</div>
                  <div><el-input v-model="form.endInterval" placeholder="请输入" maxlength="8">
                    <span slot="suffix">元</span>
                  </el-input></div>
                </div>
              </el-form-item>
              <el-form-item
                class="align-item"
                ref="deductValue"
                label="提成"
                prop="deductValue"
                :rules="$rules.required"
              >
                <el-input v-model="form.deductValue" placeholder="请输入" maxlength="8">
                  <span slot="suffix">{{ form.deductWay == 'ratio' ? '%':'元' }}</span>
                </el-input>
              </el-form-item>
            </div>
            <div v-if="itemType != 'recharge'">
              <div class="order-title-boxs">
                <span class="blueBlock"></span>
                <div><i>社保补贴</i></div>
              </div>
              <el-form-item
                class="align-item"
                ref="customerSaleDeductAmount"
                label="散客"
                prop="customerSaleDeductAmount"
              >
              <div class="flex-row">
                <el-input v-model="form.customerSocialSubsidyValue" placeholder="请输入" maxlength="8">
                  <span slot="suffix" v-if="itemType == 'serve'">{{ form.workDeductWay == 'ratio' ? '%':'元' }}</span>
                  <span slot="suffix" v-else>{{ form.saleDeductWay == 'ratio' ? '%':'元' }}</span>
                </el-input>
              </div>
              </el-form-item>
              <el-form-item
                class="align-item"
                ref="saleDeductAmount"
                label="会员"
                prop="saleDeductAmount"
              >
                <div class="flex-row">
                  <el-input v-model="form.socialSubsidyValue" placeholder="请输入" maxlength="8">
                    <span slot="suffix" v-if="itemType == 'serve'">{{ form.workDeductWay == 'ratio' ? '%':'元' }}</span>
                    <span slot="suffix" v-else>{{ form.saleDeductWay == 'ratio' ? '%':'元' }}</span>
                  </el-input>
                  
                </div>
              </el-form-item>
            </div>
            <div v-else>
              <el-form-item
                class="align-item"
                ref="socialSubsidyValue"
                label="社保补贴"
                prop="socialSubsidyValue"
                label-width="70px"
              >
                <div class="flex-row">
                  <el-input v-model="form.socialSubsidyValue" placeholder="请输入" maxlength="8">
                    <span slot="suffix">{{ form.deductWay == 'ratio' ? '%':'元' }}</span>
                  </el-input>
                </div>
              </el-form-item>
            </div>
          </el-form>
        
      </div>
      <div slot="footer" class="dialog-footer">
          <el-button @click="back">取消</el-button>
          <el-button type="primary" @click="save">确定</el-button>
        </div>
    </el-dialog>
  </div>
</template>

<script>
import drawer from "../../../components/common/drawer";
import minxin from "../../../assets/javascript/minxin.js";
export default {
  data() {
    return {
      addEditShow: false,
      addEditTitle: "",
      positionList: [],
      itemType: "",
      form: {
        id: "",
        deductType: 'startRecharge', // 新增时类型
        deductWay: 'ratio', // 新增时提成
        staffName: "", //姓名
        workDeductWay: "ratio", //提成
        deductPriceType: "original", //价格
        customerWorkDeductAmount: "",
        socialSubsidyValue: '',
        //roleIdList: '',
      }
      //attachmentList: [],
    };
  },
  mixins: [minxin],
  components: {
    drawer
  },
  created() {
    this.init();
  },
  methods: {
    back() {
      this.addEditShow = false;
    },
    //  页面初始化函数
    init() {
      this.$on("set", function(org) {
        Object.assign(this.$data, this.$options.data());
        if (org.item == 'add') {
          this.addEditTitle = "新增提成";
          this.addEditShow = true;
          this.itemType = org.type;
        } else {
          this.addEditTitle = "提成修改";
          this.addEditShow = true;
          this.form = JSON.parse(JSON.stringify(org.item));
          console.log(this.form);
          this.itemType = org.type;
        }
        
      });
    },
    handleChangeDrawer(val) {
      this.$refs["form"].clearValidate();
      this.addEditShow = false;
    },
    // 保存
    save() {
      this.$refs.form.validate((valid, object) => {
        if (valid) {
          let arr = {};
          if (this.itemType != "recharge") {
            if (this.itemType == "serve") {
              if ( this.form.workDeductAmount < 0 && this.form.customerWorkDeductAmount < 0 ) {
                this.$message("劳动提成不能小于0");
                return false;
              }
            } else {
              if (this.form.saleDeductAmount < 0) {
                this.$message("销售提成不能小于0");
                return false;
              }
            }
            arr = {
              itemId: this.form.id, //产品编号
              itemType: this.itemType, //产品类型
              deductType: this.itemType == "serve" ? "work" : "sale", //
              deductPriceType: this.form.deductPriceType,
              socialSubsidyValue: this.form.socialSubsidyValue,
              customerSocialSubsidyValue: this.form.customerSocialSubsidyValue,
              customerDeductValue: this.itemType == "serve" ? this.form.customerWorkDeductAmount : this.form.customerSaleDeductAmount,
              deductWay: this.itemType == "serve" ? this.form.workDeductWay : this.form.saleDeductWay, //this.form.deductWay, //提成方式
              deductValue: this.itemType == "serve" ? this.form.workDeductAmount : this.form.saleDeductAmount //提成值
            };
            this.$api.post(this.$url.deduct.update, arr).then(res => {
              if (res) {
                this.$api.success();
                this.addEditShow = false;
                this.$emit("change", true);
              }
            });
          } else {
            console.log(!this.form.endInterval && !this.form.startInterval);
            if (this.form.endInterval == 0) {
              return this.$message.error("充值提成价格区间不能为空")
            } else if (!this.form.endInterval && !this.form.startInterval) {
              return this.$message.error("请输入提成规则")
            }else if (Number(this.form.endInterval) < Number(this.form.startInterval)) {
              this.$message("充值提成开始金额不能大于结束金额!");
              return false;
            }
            arr = this.form
            this.$api.post(this.$url.deduct.updateRechargeRule, arr).then(res => {
              if (res) {
                this.$api.success();
                this.addEditShow = false;
                this.$emit("change", true);
              }
            });
          }
        } else {
          this.scrollView(object);
        }
      });
    },
    // //滚动到指定位置
    scrollView(object) {
      for (let i in object) {
        let dom = this.$refs[i];
        dom.$el.scrollIntoView({
          block: "center",
          behavior: "smooth"
        });
        break;
      }
    }
  }
};
</script>
<style scoped lang="less">
@import "../../../assets/css/edit.less";
 .ductway { 
    display: flex;
}
  /deep/ .el-form-item__content {
    margin-left: 0 !important;
  }
</style>
